import type { FormControl } from '@angular/forms';

import { isEmpty } from '@recruitee/utils';

const CAREER_DOMAIN_PATTERN = /^((?=[a-z0-9-]{1,63}\.)[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,12}$/;

export function careersDomainValidator(
  control: FormControl<string | null>,
): { domainPattern: boolean } | null {
  return isEmpty(control.value) || CAREER_DOMAIN_PATTERN.test(control.value)
    ? null
    : { domainPattern: true };
}
